import { FormEvent, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { useCreateOfficeMutation } from 'utils/wemble-api';

const OfficeModal = ({
  title,
  groupId,
  isOpen,
  onClose,
}: {
  title: string;
  groupId: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [name, setName] = useState('');
  const [createOffice] = useCreateOfficeMutation();

  const handleClose = () => {
    setIsSubmitting(false);
    setName('');
    onClose();
  };

  const handleSubmit = async (ev: FormEvent) => {
    setErrorMsg(undefined);
    setIsSubmitting(true);
    ev.preventDefault();
    const res = await createOffice({
      officeCreationParams: {
        name,
        group: groupId,
      },
    });
    if ('error' in res) {
      const error = res.error as any;
      if (typeof error?.data?.message === 'string') {
        setErrorMsg(error?.data?.message);
      }
      setIsSubmitting(false);
      return;
    }
    handleClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={handleClose}>{title}</ModalHeader>
        <ModalBody>
          <table className={'table'}>
            <tbody>
              <tr>
                <th scope="row" className={'control-label'}>
                  Name
                </th>
                <td>
                  <input
                    value={name}
                    type="text"
                    name="name"
                    required
                    className={'form-control'}
                    onChange={(ev) => setName(ev.target.value)}
                    disabled={isSubmitting}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          {errorMsg && <span className="text-danger">{errorMsg}</span>}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>

          <Button color="primary" type="submit" disabled={isSubmitting}>
            Add
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default OfficeModal;
